import "./UsersList.css";
import { Dropdown } from "react-bootstrap";
import {
  FaArrowLeftLong,
  FaArrowRightLong,
  FaEllipsisVertical,
  FaRegPenToSquare,
  FaRegTrashCan,
} from "react-icons/fa6";
import React, { useEffect, useState } from "react";
import CreateUser from "../CreateUser/CreateUser";
import EditUser from "../EditUser/EditUser";
import axiosInstance from "../../api/axiosInstance";

const UsersList = ({
  isCreateUser,
  isEditUser,
  setIsCreateUser,
  setIsEditUser,
  setIsNewUserAdded,
}) => {
  const [selectedUser, setSelectedUser] = useState({});
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;

  const { token } = JSON.parse(localStorage.getItem("auth"));

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await axiosInstance.get("/user/allUsers", {
          headers: { authorization: token },
        });

        if (response?.data?.data) {
          setUsers(response.data.data);
        }
      } catch (error) {
        console.error("🚀 -> fetchUsers -> error:", error);
      }
    };

    if (!isCreateUser || !isEditUser || token) fetchAllUsers();
  }, [isCreateUser, isEditUser, token]);

  const totalUsers = users.length;
  const totalPages = Math.ceil(totalUsers / recordsPerPage);

  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <>
      {isCreateUser ? (
        <CreateUser
          handleClose={() => {
            setIsCreateUser(false);
          }}
          setIsNewUserAdded={setIsNewUserAdded}
        />
      ) : isEditUser ? (
        <EditUser
          handleClose={() => {
            setIsEditUser(false);
          }}
          user={selectedUser}
          setIsNewUserAdded={setIsNewUserAdded}
        />
      ) : (
        <div className="usersListBox">
          <div className="usersListHeader">
            <div className="userListItem">
              <div className="usernameBox">
                <p>Username</p>
              </div>
              <div className="emailBox">
                <p>Email</p>
              </div>
              <div className="numbersBox">
                <p>Numbers</p>
              </div>
              <div className="actionBox"></div>
            </div>
          </div>
          <div className="usersListBody">
            {users.slice(startIndex, endIndex).map((user, index) => (
              <div className="userListItem" key={index}>
                <div className="usernameBox">
                  <p>{`${user.firstName} ${user.lastName}`}</p>
                </div>
                <div className="emailBox">
                  <p>{user.email}</p>
                </div>
                <div className="numbersBox">
                  <p>{user.phone}</p>
                </div>
                <div className="actionBox">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <FaEllipsisVertical />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          setIsEditUser(true);
                          setSelectedUser(user);
                        }}
                      >
                        <FaRegPenToSquare className="me-2 text-success" />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <FaRegTrashCan className="me-2 text-danger" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ))}
          </div>
          <div className="paginationControls">
            <button
              type="button"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              <FaArrowLeftLong size={24} />
            </button>
            <span className="pageIndicator">
              Page {currentPage} of {totalPages}
            </span>
            <button
              type="button"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              <FaArrowRightLong size={24} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UsersList;
